import { render } from "./CounselingReportCreate.vue?vue&type=template&id=49db64c2&ts=true"
import script from "./CounselingReportCreate.vue?vue&type=script&lang=ts"
export * from "./CounselingReportCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__